// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3Te2o","header":"MergedInvoice_header__nE2YO"};